import { createSubscriber, createConsumer, IEvent } from '@cian/events-log';
import { TDispatch, IApplicationState } from '../types/redux';
import { setIsCianAuthorized, setCianAuthorizedModalOpen } from '../redux';
import { selectIsCianAuthorizedModalOpen, selectRedirectAuthorizationModal } from '../selectors/calculator';

export function subscribeOnAuthentication(): (dispatch: TDispatch, getState: () => IApplicationState) => void {
  return (dispatch: TDispatch, getState: () => IApplicationState) => {
    if (typeof window === 'undefined') {
      return;
    }

    createConsumer({ topic: 'user' }).subscribe(
      createSubscriber((event: IEvent<unknown>) => {
        if (event.type === 'authenticated') {
          dispatch(setIsCianAuthorized(true));
          const state = getState();
          const redirectUrl = selectRedirectAuthorizationModal(state);
          if (selectIsCianAuthorizedModalOpen(state) && redirectUrl) {
            window.open(redirectUrl, '_self');
          }
        } else if (event.type === 'authentication_modal_closed') {
          dispatch(setCianAuthorizedModalOpen(false));
        }
      }),
    );
  };
}
